var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.465,
    height: 552.326,
    viewBox: "0 0 799.465 552.326",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_293",
    "data-name": "Group 293",
    transform: "translate(-560.267 -263.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4661-209",
    "data-name": "Path 4661",
    d: "M1352.3,232.384H580.059a13.747,13.747,0,0,0-13.613,13.848v524.66a13.74,13.74,0,0,0,13.613,13.819H1352.3a13.741,13.741,0,0,0,13.613-13.819V246.232a13.747,13.747,0,0,0-13.611-13.848Z",
    transform: "translate(-6.18 31.451)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4660-210",
    "data-name": "Path 4660",
    d: "M1236.279,232.384H578.049a11.628,11.628,0,0,0-11.6,11.627V684.536a11.623,11.623,0,0,0,11.6,11.6h658.229a11.623,11.623,0,0,0,11.6-11.6V244.011a11.628,11.628,0,0,0-11.6-11.627Z",
    transform: "translate(-3.436 34.195)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4021-211",
    "data-name": "Path 4021",
    d: "M1328.244,232.384h-748.6a13.225,13.225,0,0,0-13.2,13.223V746.614a13.219,13.219,0,0,0,13.2,13.2h748.6a13.219,13.219,0,0,0,13.2-13.2V245.608a13.224,13.224,0,0,0-13.194-13.223Z",
    transform: "translate(-4.945 34.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_292",
    "data-name": "Group 292",
    transform: "translate(137 136.965)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_848",
    "data-name": "Ellipse 848",
    cx: 183.5,
    cy: 183.5,
    r: 183.5,
    transform: "translate(640 220.035)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_859",
    "data-name": "Ellipse 859",
    cx: 105.981,
    cy: 84.761,
    rx: 105.981,
    ry: 84.761,
    transform: "translate(687.778 414.509) rotate(-43.502)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5058-212",
    "data-name": "Path 5058",
    d: "M464.7,117.735H374.473a15.784,15.784,0,0,0-15.784,15.784v39.614a15.784,15.784,0,0,0,15.784,15.784h15.352l1.993,13.264a3.353,3.353,0,0,0,5.131,2.322l24.233-15.586H464.7a15.784,15.784,0,0,0,15.784-15.784V133.519A15.784,15.784,0,0,0,464.7,117.735Z",
    transform: "translate(399.327 249.458)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_860",
    "data-name": "Ellipse 860",
    cx: 20.563,
    cy: 20.564,
    rx: 20.563,
    ry: 20.564,
    transform: "translate(856.88 344.257)",
    fill: "#6c63ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.cc7d3d14b23f00ff079f00d797dfbc94.svg";
export { ForwardRef as ReactComponent };